/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Authorize_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not sign in to the MCP server." |
*
* @param {Mcp_Servers_Authorize_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_authorize_error = /** @type {((inputs?: Mcp_Servers_Authorize_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Authorize_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Anmeldung beim MCP-Server ist fehlgeschlagen.")
	return /** @type {LocalizedString} */ ("Could not sign in to the MCP server.")
});